import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button } from '@/components/ui/button'
import { Label } from '@/components/ui/label'
import { Input } from '@/components/ui/input'
import Modal, { hideModal, showModal } from '../../widgets/modal'
import { actions } from '../Customers/customers.slice'
import {
	selectSelectedAccounts,
	selectFilters,
} from '../Customers/customers.selectors'

import { fetchCustomers } from '../Customers/customers.asynActions'
import { deleteAccount } from '../Account/account.asyncActions'
import { Formik } from 'formik'
import { object as YupObject, string as YupString } from 'yup'
import classNames from 'classnames'
import BusyIndicator, { REGIONS } from '../../widgets/busyIndicator'

const { setSelectedCustomerModal, setSelectedAccounts } = actions

const DeleteAccountModal = () => {
	const dispatch = useDispatch()
	const resetModal = () => {
		dispatch(setSelectedCustomerModal(null))
	}

	const selectedAccounts = useSelector(selectSelectedAccounts)
	const filters = useSelector(selectFilters)
	const selectedAccount = selectedAccounts[0]
	const accountName = selectedAccount.account

	useEffect(() => {
		dispatch(showModal())
	}, [dispatch])
	const handleClose = () => {
		dispatch(hideModal())
		resetModal()
	}

	const validationSchema = YupObject().shape({
		accountName: YupString()
			.required('Account Name is Required')
			.matches(accountName, 'Account Name does not match'),
	})
	const initialValues = {
		accountName: '',
	}
	return (
		<Formik
			enableReinitialize={true}
			initialValues={initialValues}
			validationSchema={validationSchema}
			onSubmit={(values, { setSubmitting, resetForm }) => {
				dispatch(deleteAccount(selectedAccount.id)).then(({ payload }) => {
					payload &&
						dispatch(
							fetchCustomers({
								filters,
								useCaching: false,
							})
						)
					dispatch(setSelectedCustomerModal(null))
					dispatch(setSelectedAccounts([]))
					resetForm()
					setSubmitting(false)
				})
			}}
		>
			{({
				values,
				errors,
				touched,
				isSubmitting,
				handleChange,
				handleBlur,
				handleSubmit,
			}) => {
				const footer = (
					<>
						<Button
							className='h-50 w-190'
							variant='outline'
							onClick={handleClose}
						>
							Cancel
						</Button>
						<Button
							className='h-50 w-190'
							onClick={handleSubmit}
							disabled={isSubmitting}
						>
							<BusyIndicator region={REGIONS.DELETE_DUPLICATE_ACCOUNT}>
								Delete Account
							</BusyIndicator>
						</Button>
					</>
				)
				return (
					<>
						<Modal
							footer={footer}
							reset={resetModal}
							size='md'
							title='Are Your Sure You Want to Delete This Account?'
						>
								<div className='f-14'>
									<div className='form-group'>
									<h6 className='mb-25'>
										Please confirm deletion by typing the account name.
									</h6>
										<Label className='font-weight-normal'>{`Type "${selectedAccount.account}"`}</Label>
										<Input
											type='text'
											name='accountName'
											value={values.accountName}
											onChange={handleChange}
											onBlur={handleBlur}
											className={classNames({
												error: touched.accountName && errors.accountName,
											})}
										/>
									{touched.accountName && errors.accountName && (
										<div className='error-message'>{errors.accountName}</div>
									)}
									</div>
								</div>
						</Modal>
					</>
				)
			}}
		</Formik>
	)
}
export default DeleteAccountModal
